"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OrderInformation = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const addressTypes_1 = require("../../../../models/addressTypes");
const constants_1 = require("../../../../constants");
const Address_1 = require("./Address");
const OrderInformation = ({ shippingAddress, billingAddress }) => {
    const { t } = (0, react_i18next_1.useTranslation)(constants_1.constants.TRANSLATIONS_NAMESPACE);
    return (react_1.default.createElement("div", { className: "boutik-customer-account-order-details-order-informations-container" },
        react_1.default.createElement("p", { className: "boutik-customer-account-order-details-order-informations-title" }, t("customerAccount.orders.orderDetails.orderInformation")),
        react_1.default.createElement("div", { className: "boutik-customer-account-order-details-order-informations-adresses-container" },
            react_1.default.createElement(Address_1.Address, { address: billingAddress, type: addressTypes_1.AddressTypes.BILLING }),
            react_1.default.createElement(Address_1.Address, { address: shippingAddress, type: addressTypes_1.AddressTypes.SHIPPING }))));
};
exports.OrderInformation = OrderInformation;
//# sourceMappingURL=OrderInformation.js.map